import { render, staticRenderFns } from "./SelectItemButtons.vue?vue&type=template&id=177c79ab&scoped=true&"
import script from "./SelectItemButtons.vue?vue&type=script&lang=js&"
export * from "./SelectItemButtons.vue?vue&type=script&lang=js&"
import style0 from "./SelectItemButtons.vue?vue&type=style&index=0&id=177c79ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177c79ab",
  null
  
)

export default component.exports